import React, {useEffect, useState} from 'react';
import postIcon from '../../../imgs/post.svg';
import departmentIcon from '../../../imgs/departmenticon.svg';
import toparrow from '../../../imgs/akar-icon.svg';
import {Modal} from 'antd';
import IntroModal from './../../modals/introModal/introModal';
import {useSelector} from 'react-redux';

const HomeCard = ({bounty}) => {
  const {
    fullName,
    company,
    title,
    bountyType,
    demandPrice,
    department,
    reason,
    offers,
  } = bounty;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const userProfile = useSelector((state) => state.strapiRes);
  const [intro, setIntro] = useState(false);

  useEffect(() => {
    const result = offers.some(
      (value) => value.introPerson.id == userProfile.id,
    );
    setIntro(result);
  }, [offers]);

  //   function afterOpenModal() {
  //     // references are now sync'd and can be accessed.
  //     subtitle.style.color = '#f00';
  //   }

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={false}
        className="modal-body">
        <IntroModal
          bounty={bounty}
          handleCancel={() => {
            setIsModalVisible(false);
          }}
        />
      </Modal>
      <div className="feed-card-wrapper">
        {/* <div > */}
        <div className="row m-0 justify-content-between">
          <h2 className="heading">
            {' '}
            <img
              src={bountyType == 'person' ? postIcon : departmentIcon}
              alt="logo"
            />
            {bountyType == 'person' ? fullName : company}
          </h2>
          <h2 className="small-heading">${demandPrice}</h2>
        </div>
        <p className="color-black">
          {bountyType == 'person' ? `${title} at ${company} ` : department}
        </p>
        {/* </div> */}
        <div className="row m-0 justify-content-between">
          <span>For {reason}</span>
          {intro ? null : (
            <a onClick={showModal}>
              <img src={toparrow} alt="logo" />
              Make intro
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeCard;
